"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

var _LineChart = _interopRequireDefault(require("../components/LineChart"));

var _BarChart = _interopRequireDefault(require("../components/BarChart"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Admin/CardInfoV1"));

var _PieChart = _interopRequireDefault(require("../components/PieChart.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "admin-v1",
  components: {
    LineChart: _LineChart.default,
    BarChart: _BarChart.default,
    CardInfo: _CardInfoV.default,
    PieChart: _PieChart.default
  },
  props: {
    cardData: Object,
    sevenDays: Array,
    channelLabels: Array,
    channelValues: Array,
    topRate: Array,
    bottomRate: Array,
    topOrgs: Array,
    topAgents: Array,
    loading: Boolean,
    lineGraphLabel: Array,
    sevenDaysNotEmpty: Boolean,
    successDate: String,
    failDate: String,
    channelDate: String,
    numberOfDecimal: Boolean,
    smsCountLabels: Array,
    smsCountValues: Array,
    agentsLabels: Array,
    agentsValues: Array,
    paymentYesterdayLabels: Array,
    paymentYesterdayValues: Array,
    smsColor: String,
    agentsColor: String,
    paymentColor: String,
    sevenDaysColor: String
  },
  computed: {
    cardInfo: function cardInfo() {
      return [{
        icon: {
          style: "font-size: 4.5em; color: YellowGreen",
          class: "fas fa-check-circle"
        },
        count: {
          decimal: false,
          endVal: parseInt(this.cardData.totalCountQueryApi),
          unit: this.$t("dashboard.merchant.smsUnit"),
          label: this.$t("dashboard.queryApiTimes")
        }
      }, {
        icon: {
          style: "font-size: 4.2em; color: SteelBlue",
          class: "fas fa-handshake"
        },
        count: {
          decimal: false,
          endVal: parseFloat(this.cardData.RechargeSuccess),
          unit: this.$t("dashboard.merchant.smsUnit"),
          label: this.$t("dashboard.rechargeSuccess")
        }
      }, {
        icon: {
          style: "font-size: 4.3em; color: Coral",
          class: "fas fa-paper-plane"
        },
        count: {
          decimal: false,
          endVal: parseInt(this.cardData.SubmitSuccess),
          unit: this.$t("dashboard.merchant.smsUnit"),
          label: this.$t("dashboard.submitSuccess")
        }
      }, {
        icon: {
          style: "font-size: 4em; color: ForestGreen",
          class: "fas fa-money-check-alt"
        },
        count: {
          decimal: true,
          endVal: parseFloat(this.cardData.processTotalSumMoneyFrom),
          unit: this.$t("common.USD"),
          label: this.$t("dashboard.totalPayAmount"),
          numberOfDecimal: this.numberOfDecimal
        }
      }];
    }
  },
  filters: {
    formatNumber: function formatNumber(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
exports.default = _default;